import { render } from "./totop.vue?vue&type=template&id=96e1ef94&scoped=true&bindings={\"img1\":\"data\",\"img2\":\"data\",\"change\":\"data\",\"top0\":\"data\",\"hasToTop\":\"props\",\"getTop\":\"options\"}"
import script from "./totop.vue?vue&type=script&lang=js"
export * from "./totop.vue?vue&type=script&lang=js"

import "./totop.vue?vue&type=style&index=0&id=96e1ef94&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-96e1ef94"

export default script